<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import { cn } from 'cn'
import { Presence, useForwardExpose } from 'reka-ui'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  error: Maybe<string>
  class?: HTMLAttributes['class']
}>()

const { forwardRef } = useForwardExpose()
</script>

<template>
  <Presence
    :present="!!error"
    force-mount
  >
    <UiAlert
      v-show="!!error"
      :ref="forwardRef"
      color="destructive"
      :data-state="!!error ? 'open' : 'closed'"
      :class="cn('origin-bottom-left', $style.alert, props.class)"
    >
      <template #description>
        <div class="flex gap-2">
          <UiIcon
            name="docue:alert-circle"
            size="1rem"
            class="h-[1lh] shrink-0"
          />
          {{ error }}
        </div>
      </template>
    </UiAlert>
  </Presence>
</template>

<style module>
.alert {
  &[data-state='open'] {
    animation: open 180ms ease-out;
  }
  &[data-state='closed'] {
    animation: close 180ms ease-in;
  }
}

@keyframes open {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes close {
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
}
</style>
